import type { ExperimentConfig } from '../@types'

// DEV-35166 — i2.2 extended to the male funnels, built on the crScoring engine instead of the legacy
// identsOverride path. All six areas share one transform: the scoring spec and the premium ladder are
// the same everywhere, and the Low CR arm is derived from whichever base paywall the country resolves to.
const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_ml_price_prediction_high_wtp_i2_3~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_3/withHighWtpPricing'),
			},
		},
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_ml_price_prediction_high_wtp_i2_3~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_3/withHighWtpPricing'),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_ml_price_prediction_high_wtp_i2_3~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_3/withHighWtpPricing'),
			},
		},
		'activity-male-tai-chi-yoga-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_ml_price_prediction_high_wtp_i2_3~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_3/withHighWtpPricing'),
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_ml_price_prediction_high_wtp_i2_3~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_3/withHighWtpPricing'),
			},
		},
		'activity-male-tai-chi-walking-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-walking-al&exp=web_ml_price_prediction_high_wtp_i2_3~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_ml_price_prediction_high_wtp_i2_3/withHighWtpPricing'),
			},
		},
	},
]

export default config
